import { render, staticRenderFns } from "./UploadTerms.vue?vue&type=template&id=1d42ec21&"
import script from "./UploadTerms.vue?vue&type=script&lang=js&"
export * from "./UploadTerms.vue?vue&type=script&lang=js&"
import style0 from "./UploadTerms.vue?vue&type=style&index=0&id=1d42ec21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports